import api from "../../../../../services/api";

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import * as globalComponents from "../../../../../components";
import utils from "../../../../../shared/utils.js";

import "../../styles.css";

export default function LawsAndDecrees() {
  const { accessType } = useParams();
  const [data, setData] = useState([]);
  const dir = [
    {
      title: "Legislação",
      url: `/${accessType}/legislacao`,
    },
  ];

  const parseData = (data) => {
    const [day, month, year] = [
      String(data).substring(6, 8),
      String(data).substring(4, 6),
      String(data).substring(0, 4),
    ];
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    window.scroll(0, 0);
    async function fetchData() {
      await api
        .get("/leis-e-decretos")
        .then((response) => {
          const orderedData = response.data.sort((a, b) => b.Data - a.Data);

          setData(orderedData);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    fetchData();
  }, []);

  return (
    <>
      <globalComponents.Header />

      <globalComponents.Breadcrumbs title="Leis e Decretos" dir={dir} />

      <div className="container">
        <div className="title__publications">
          <strong>Leis e Decretos</strong>
          <div className="responsive-table-container">
            <table className="legislation-table">
              <thead>
                <tr>
                  <th>Título</th>
                  <th>Descrição</th>
                  <th>Data de Publicação</th>
                  <th>Anexo</th>
                </tr>
              </thead>
              <tbody>
                {data.map((value, index) => {
                  const link = `/${accessType}/legislacao/leis_e_decretos/${utils.slugifyTitle(
                    value.Titulo
                  )}_${value.Codigo}`;

                  return (
                    <tr key={index}>
                      <td>
                        <a href={link} className="title-link">
                          {value.Titulo?.replaceAll("<br />", "")}
                        </a>
                      </td>
                      <td>{value.Subtitulo?.replaceAll("<br />", "")}</td>
                      <td>{parseData(value.Data) || "-"}</td>
                      <td>
                        <a
                          href={value.Link}
                          className={value.Link ? "title-link" : ""}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {value.Link?.split("/").pop() || "N/A"}
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <globalComponents.Footer />
    </>
  );
}
